import { combineReducers } from 'redux';

import {
  uploadsReducer,
  experimentListsReducer,
  authenticationReducer,
  customMessagesReducer,
  createUserReducer,
  setPasswordReducer,
  resetPasswordReducer,
  contactUsReducer,
  errorReducer,
  localesReducer,
  accountsReducer,
  ordersReducer,
  filesReducer,
  initialPayloadReducer,
  buildsReducer,
  cookiePolicyReducer,
  notificationsReducer,
  accountInfoReducer,
  clinicalReportReducer,
  projectPickerReducer,
} from '@store/reducers';

import {
  ICustomMessagesState,
  IUploadsState,
  CreateUserState,
  ISetPasswordState,
  ResetPasswordState,
  ContactUsState,
  ErrorState,
  AuthenticationState,
  ILocalesState,
  IAccountsState,
  IOrdersState,
  IFileState,
  IInitialPayloadState,
  IExperimentListsState,
  INotificationsState,
  ICookiePolicyState,
  IBuildsState,
  IProjectPicker,
} from '@store/types';

import { ClinicalReport, AccountInfo } from '@store/actions';

export interface IApplicationState {
  uploads: IUploadsState;
  authentication: AuthenticationState;
  createUser: CreateUserState;
  setPassword: ISetPasswordState;
  resetPassword: ResetPasswordState;
  contactUs: ContactUsState;
  error: ErrorState;
  customMessages: ICustomMessagesState;
  locales: ILocalesState;
  accounts: IAccountsState;
  orders: IOrdersState;
  files: IFileState;
  initialPayload: IInitialPayloadState;
  experimentLists: IExperimentListsState;
  builds: IBuildsState;
  notifications: INotificationsState;
  cookiePolicy: ICookiePolicyState;
  accountInfo: AccountInfo;
  clinicalReport: ClinicalReport;
  projectPicker: IProjectPicker;
}

export const rootReducer = combineReducers<IApplicationState>({
  uploads: uploadsReducer,
  authentication: authenticationReducer,
  createUser: createUserReducer,
  setPassword: setPasswordReducer,
  resetPassword: resetPasswordReducer,
  contactUs: contactUsReducer,
  error: errorReducer,
  customMessages: customMessagesReducer,
  locales: localesReducer,
  accounts: accountsReducer,
  orders: ordersReducer,
  files: filesReducer,
  initialPayload: initialPayloadReducer,
  experimentLists: experimentListsReducer,
  builds: buildsReducer,
  notifications: notificationsReducer,
  cookiePolicy: cookiePolicyReducer,
  accountInfo: accountInfoReducer,
  clinicalReport: clinicalReportReducer,
  projectPicker: projectPickerReducer,
});
